var _rect, _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavKeyboardZoom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 61,
    viewBox: "0 0 102 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 100,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2992 19.5848V21.9522M70.2992 36.1566C75.5292 36.1566 79.7688 31.9169 79.7688 26.687V21.9522C79.7688 16.7222 75.5292 12.4825 70.2992 12.4825C65.0693 12.4825 60.8296 16.7222 60.8296 21.9522V26.687C60.8296 31.9169 65.0693 36.1566 70.2992 36.1566Z",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5029 22.3417L88.5029 20.3417M86.5029 22.3417L84.5029 20.3417M86.5029 22.3417L86.5029 18.5062L86.5029 14.6707",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3583)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4145_3583",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7758 22.2261C70.7758 20.562 72.1248 19.213 73.7888 19.213C75.4529 19.213 76.8019 20.562 76.8019 22.2261V29.5103C78.8984 29.6979 81.2056 30.0375 82.5638 30.377C84.5939 30.8845 87.1316 32.6859 87.1316 35.4524L87.1317 39.5127C87.1317 41.0353 86.7238 46.1114 79.0608 46.1114C75.9222 46.1114 74.0691 45.34 72.975 44.0825L65.409 36.5165C64.2323 35.3398 64.2323 33.432 65.409 32.2554C66.5857 31.0787 68.4934 31.0787 69.6701 32.2554L70.7758 33.3611V22.2261Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7758 22.2261C70.7758 20.562 72.1248 19.213 73.7888 19.213C75.4529 19.213 76.8019 20.562 76.8019 22.2261V29.5103C78.8984 29.6979 81.2056 30.0375 82.5638 30.377C84.5939 30.8845 87.1316 32.6859 87.1316 35.4524L87.1317 39.5127C87.1317 41.0353 86.7238 46.1114 79.0608 46.1114C75.9222 46.1114 74.0691 45.34 72.975 44.0825L65.409 36.5165C64.2323 35.3398 64.2323 33.432 65.409 32.2554C66.5857 31.0787 68.4934 31.0787 69.6701 32.2554L70.7758 33.3611V22.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8019 29.5103H74.8019V31.3394L76.6237 31.5024L76.8019 29.5103ZM82.5638 30.377L83.0488 28.4367L82.5638 30.377ZM87.1316 35.4524H85.1316V35.4524L87.1316 35.4524ZM87.1317 39.5127H89.1317V39.5127L87.1317 39.5127ZM72.975 44.0825L74.4839 42.7697L74.4383 42.7174L74.3892 42.6683L72.975 44.0825ZM65.409 36.5165L63.9948 37.9307H63.9948L65.409 36.5165ZM65.409 32.2554L66.8232 33.6696L66.8232 33.6696L65.409 32.2554ZM69.6701 32.2554L68.2559 33.6696L69.6701 32.2554ZM70.7758 33.3611L69.3616 34.7753L72.7758 38.1895V33.3611H70.7758ZM73.7888 17.213C71.0202 17.213 68.7758 19.4574 68.7758 22.2261H72.7758C72.7758 21.6666 73.2293 21.213 73.7888 21.213V17.213ZM78.8019 22.2261C78.8019 19.4574 76.5575 17.213 73.7888 17.213V21.213C74.3483 21.213 74.8019 21.6666 74.8019 22.2261H78.8019ZM78.8019 29.5103V22.2261H74.8019V29.5103H78.8019ZM83.0488 28.4367C81.5471 28.0613 79.1242 27.7101 76.9801 27.5183L76.6237 31.5024C78.6725 31.6857 80.864 32.0136 82.0787 32.3173L83.0488 28.4367ZM89.1316 35.4524C89.1316 33.4071 88.1816 31.774 86.9999 30.6304C85.8385 29.5064 84.3758 28.7684 83.0488 28.4367L82.0787 32.3173C82.7819 32.4931 83.6031 32.9095 84.2181 33.5047C84.8128 34.0803 85.1316 34.7312 85.1316 35.4524H89.1316ZM89.1317 39.5127L89.1316 35.4524L85.1316 35.4524L85.1317 39.5127L89.1317 39.5127ZM79.0608 48.1114C83.3747 48.1114 86.0679 46.6516 87.5881 44.5583C89.0224 42.5833 89.1317 40.4129 89.1317 39.5127H85.1317C85.1317 40.1352 85.0369 41.2641 84.3516 42.2078C83.7521 43.0332 82.4099 44.1114 79.0608 44.1114V48.1114ZM71.4661 45.3952C73.0932 47.2654 75.6269 48.1114 79.0608 48.1114V44.1114C76.2174 44.1114 75.0449 43.4147 74.4839 42.7697L71.4661 45.3952ZM74.3892 42.6683L66.8232 35.1023L63.9948 37.9307L71.5608 45.4967L74.3892 42.6683ZM66.8232 35.1023C66.4276 34.7067 66.4276 34.0652 66.8232 33.6696L63.9948 30.8412C62.0371 32.7989 62.0371 35.973 63.9948 37.9307L66.8232 35.1023ZM66.8232 33.6696C67.2188 33.274 67.8603 33.274 68.2559 33.6696L71.0843 30.8412C69.1266 28.8834 65.9525 28.8834 63.9948 30.8412L66.8232 33.6696ZM68.2559 33.6696L69.3616 34.7753L72.19 31.9468L71.0843 30.8412L68.2559 33.6696ZM68.7758 22.2261V33.3611H72.7758V22.2261H68.7758Z",
    fill: "#50307E",
    mask: "url(#path-4-inside-1_4145_3583)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5029 9.88858L86.5029 17.5595M86.5029 9.88858L84.5029 11.8886M86.5029 9.88858L88.5029 11.8886",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.833 21.998C48.833 21.4457 48.3853 20.998 47.833 20.998C47.2807 20.998 46.833 21.4457 46.833 21.998V26.998H41.833C41.2807 26.998 40.833 27.4457 40.833 27.998C40.833 28.5502 41.2807 28.998 41.833 28.998H46.833V33.998C46.833 34.5502 47.2807 34.998 47.833 34.998C48.3853 34.998 48.833 34.5502 48.833 33.998V28.998H53.833C54.3853 28.998 54.833 28.5502 54.833 27.998C54.833 27.4457 54.3853 26.998 53.833 26.998H48.833V21.998Z",
    fill: "#50307E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4145_3583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 17.1151C14.6635 17.1151 12.2725 19.303 12.2725 22.1151V34.1151C12.2725 36.9273 14.6635 39.1151 17.4967 39.1151H30.1693C33.0025 39.1151 35.3936 36.9273 35.3936 34.1151V22.1151C35.3936 19.303 33.0025 17.1151 30.1693 17.1151H17.4967Z",
    fill: "white",
    stroke: "#50307E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3299 31.2087C17.9347 31.2087 17.5629 31.1333 17.2145 30.9825C16.8661 30.8317 16.5619 30.6263 16.3019 30.3663C16.0471 30.1063 15.8443 29.8047 15.6935 29.4615C15.5427 29.1131 15.4673 28.7413 15.4673 28.3461C15.4673 27.9509 15.5427 27.5817 15.6935 27.2385C15.8443 26.8901 16.0471 26.5859 16.3019 26.3259C16.5619 26.0659 16.8661 25.8605 17.2145 25.7097C17.5629 25.5589 17.9347 25.4835 18.3299 25.4835C18.6159 25.4835 18.8889 25.5199 19.1489 25.5927C19.4141 25.6655 19.6559 25.7695 19.8743 25.9047C20.0979 26.0347 20.2981 26.1933 20.4749 26.3805C20.6517 26.5625 20.7999 26.7679 20.9195 26.9967L19.8275 27.5895C19.6715 27.3087 19.4687 27.0877 19.2191 26.9265C18.9747 26.7653 18.6783 26.6847 18.3299 26.6847C18.1011 26.6847 17.8879 26.7289 17.6903 26.8173C17.4979 26.9057 17.3289 27.0279 17.1833 27.1839C17.0377 27.3347 16.9233 27.5115 16.8401 27.7143C16.7569 27.9119 16.7153 28.1225 16.7153 28.3461C16.7153 28.5697 16.7569 28.7829 16.8401 28.9857C16.9233 29.1833 17.0377 29.3601 17.1833 29.5161C17.3289 29.6669 17.4979 29.7865 17.6903 29.8749C17.8879 29.9633 18.1011 30.0075 18.3299 30.0075C18.6783 30.0075 18.9747 29.9269 19.2191 29.7657C19.4687 29.6045 19.6715 29.3835 19.8275 29.1027L20.9195 29.6955C20.7999 29.9243 20.6517 30.1323 20.4749 30.3195C20.2981 30.5015 20.0979 30.6601 19.8743 30.7953C19.6559 30.9253 19.4141 31.0267 19.1489 31.0995C18.8889 31.1723 18.6159 31.2087 18.3299 31.2087ZM22.3075 25.5771L24.0313 27.9639L25.7707 25.5771H26.9017V31.1151H25.6537V27.7065L24.0391 29.9373L22.4167 27.6987V31.1151H21.1765V25.5771H22.3075ZM27.6021 25.5771H29.4897C29.8797 25.5771 30.2463 25.6499 30.5895 25.7955C30.9327 25.9411 31.2317 26.1387 31.4865 26.3883C31.7413 26.6379 31.9415 26.9317 32.0871 27.2697C32.2379 27.6025 32.3133 27.9613 32.3133 28.3461C32.3133 28.7309 32.2379 29.0923 32.0871 29.4303C31.9415 29.7631 31.7413 30.0543 31.4865 30.3039C31.2317 30.5535 30.9327 30.7511 30.5895 30.8967C30.2463 31.0423 29.8797 31.1151 29.4897 31.1151H27.6021V25.5771ZM29.4897 29.9763C29.7237 29.9763 29.9369 29.9347 30.1293 29.8515C30.3217 29.7631 30.4855 29.6461 30.6207 29.5005C30.7611 29.3497 30.8677 29.1755 30.9405 28.9779C31.0185 28.7803 31.0575 28.5697 31.0575 28.3461C31.0575 28.1225 31.0185 27.9119 30.9405 27.7143C30.8677 27.5167 30.7611 27.3451 30.6207 27.1995C30.4855 27.0487 30.3217 26.9317 30.1293 26.8485C29.9369 26.7601 29.7237 26.7159 29.4897 26.7159H28.8423V29.9763H29.4897Z",
    fill: "#50307E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3583",
    x: 58.5265,
    y: 13.213,
    width: 42.6051,
    height: 46.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3583",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4145_3583",
    x: 5.27246,
    y: 10.1151,
    width: 45.1211,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.192157 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3583",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavKeyboardZoom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_keyboard_zoom.226cd1562f36f27d912a77d1b158c299.svg";